import React from "react";
import PropTypes from "prop-types";
import styles from "../RouteRow/RouteRow.scss";

const RouteDepartureSeparator = ({ country }) => {
  if (!country) {
    return null;
  }

  return (
    <div className={styles.departureCountry}>
      <div className={styles.region}>{country}</div>
      <div className={styles.separator} />
    </div>
  );
};

RouteDepartureSeparator.propTypes = {
  country: PropTypes.string
};

export default RouteDepartureSeparator;
